import { extendTheme, StyleProps } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const FONT_FAMILY_DEFAULT =
  '"ヒラギノ角ゴ Pro W3", Hiragino Kaku Gothic Pro, "メイリオ", Meiryo, Osaka, "ＭＳ Ｐゴシック", MS PGothic, sans-serif';

const theme = extendTheme({
  config: {
    cssVarPrefix: 'chakra',
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  colors: {
    // prettier-ignore
    brand: {
       50: '#ccffd2', // hsv(128,  20, 100)
      100: '#91f29e', // hsv(128,  40,  95)
      200: '#56d868', // hsv(128,  60,  85), dark
      300: '#26bf3a', // hsv(128,  80,  75), dark:hover
      400: '#10a524', // hsv(128,  90,  65), dark:active
      500: '#008e14', // hsv(128, 100,  55), light, company brand color
      600: '#00720f', // hsv(128, 100,  45), light:hover
      700: '#00590b', // hsv(128, 100,  35), light:active
      800: '#004c0a', // hsv(128, 100,  30)
      900: '#003f08', // hsv(128, 100,  25)
      company: '#008e14',
    },
  },
  fonts: {
    body: FONT_FAMILY_DEFAULT,
    heading: FONT_FAMILY_DEFAULT,
  },
  components: {
    Container: {
      baseStyle: {
        maxW: ['container.md', null, 'container.lg'],
      },
    },
    Link: {
      baseStyle: (props: StyleProps) => ({
        color: mode('brand.500', 'brand.200')(props),
      }),
    },
  },
  semanticTokens: {
    colors: {
      primaryDark: {
        default: '#005F00',
        _dark: 'white',
      },
      primaryMain: {
        default: '#008E14',
        _dark: 'white',
      },
      primaryLight: {
        default: '#C3E6C1',
        _dark: 'white',
      },
      statusHighlight: {
        default: '#856404',
        _dark: 'white',
      },
      statusPremium: {
        default: '#D6BF51',
        _dark: 'white',
      },
      statusAlert: {
        default: '#BE0123',
        _dark: 'white',
      },
      alertsSuccess: {
        default: '#D4EDDA',
        _dark: 'white',
      },
      alertDanger: {
        default: '#FFE9E9',
        _dark: 'white',
      },
      alertWarning: {
        default: '#FFF3CD',
        _dark: 'white',
      },
      textPrimary: {
        default: '#222222',
        _dark: 'white',
      },
      textSecondary: {
        default: '#737373',
        _dark: 'white',
      },
      textDisabled: {
        default: '#999999',
        _dark: 'white',
      },
      textWhite: {
        default: '#FFFFFF',
        _dark: 'white',
      },
      textLink: {
        default: '#007bff',
        _dark: 'white',
      },
      borderLight: {
        default: '#D8D8DB',
        _dark: 'white',
      },
      backgroundDark: {
        default: '#B4B4B4',
        _dark: 'white',
      },
      backgroundMedium: {
        default: '#EFEFEF',
        _dark: 'white',
      },
      backgroundLight: {
        default: '#FAFAFA',
        _dark: 'white',
      },

      navbar: {
        default: 'white',
      },
      navbarBottom: {
        default: 'white',
      },
      searchBar: {
        default: '#F8F8F8',
      },
      searchBarPlaceholder: {
        default: 'gray.400',
      },
      tagInput: {
        default: 'white',
      },
      tagInputListOdd: {
        default: 'gray.50',
      },
      tagInputListHover: {
        default: 'gray.100',
      },
      linkText: {
        default: 'black',
      },
      footer: {
        default: '#F8F8F8',
      },
      footerText: {
        default: '#434343',
      },
      awardGold: {
        default: '#968650',
      },
    },
    shadows: {
      navbar: {
        default: 'lg',
      },
    },
  },
});

export default theme;
